export namespace FormatHelper {
  export const letter = (index: number) => {
    return index <= 0 ? 'a' : index >= 26 ? 'z' : String.fromCharCode('a'.charCodeAt(0) + index);
  };

  export const pluralize = (count: number, word: string, plural?: string) => {
    return `${count} ${pluralizeWord(word, count, plural)}`;
  };

  export const pluralizeWord = (word: string, count?: number, plural?: string) => {
    if (!word) {
      return '';
    }
    if (count === 1) {
      return word;
    }
    if (!plural) {
      return word + 's';
    }
    else if (plural[0] === '+') {
      return word + plural.substring(1);
    }
    else {
      return plural;
    }
  };

  export const escapeHtml = (str: string): string => {
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  };

  export const serializeObject = <T extends object>(object: T) => {
    let result = [];
    for (const key in object) {
      result.push(`${key}=${object[key] as any}`);
    }
    return result.join(', ');
  };
}
